import React from 'react'
import { useSelector } from 'react-redux'

import CircleTabs from '../../circle/CircleTabs'

import ComingSoon from 'components/ComingSoon'

import PostsSection from './Posts'
import References from './References'
import GroupActivity from './GroupActivity'
import GroupOutcome from './GroupOutcome'
import SubGroups from './SubGroups'
import PleaseWait from 'components/PleaseWait'

import { useCircle, useCircleMembership } from 'circle/circle.selectors'
import { useTheme } from '@material-ui/core'

const selectForTertiaryContent = ({
  navigation: { stack },
  session: { value: profile },
  post: outcome,
  group: { value: { group, membership } = {} }
}) => ({ stack, group, membership, outcome, profile })


const CLOSED_GROUP_WITH_OUTCOME_TAB_FILTER = ({ type }) =>
  type !== 'groups/group/activity'
const CLOSED_GROUP_WITHOUT_OUTCOME_TAB_FILTER = ({ type }) =>
  type !== 'groups/group/activity' && type !== 'groups/group/outcome'
const OPEN_GROUP_TAB_FILTER = ({ type }) => type !== 'groups/group/outcome'

const isAllowedToViewContent = (group, membership) => {
  return (group && group.privacy !== 'PRIVATE') || membership
}

const PostsDivision = ({
  onShowCloseDialog
}) => {
  const group = useCircle()
  const membership = useCircleMembership()
  if (!group) {
    return <PleaseWait />
  }

  if (membership && !group.closed) {
    return (
      <PostsSection
        onShowCloseDialog={onShowCloseDialog}
      />
    )
  }

  if (group.privacy === 'PRIVATE') {
    return <PleaseWait i18nKey="group.only_visible_to_members" />
  }

  return (
    <PostsSection
      onShowCloseDialog={onShowCloseDialog}
    />
  )
}

export const useTertiaryTabFilter = () => {
  const group = useCircle()

  return group?.closed
    ? group.outcome
      ? CLOSED_GROUP_WITH_OUTCOME_TAB_FILTER
      : CLOSED_GROUP_WITHOUT_OUTCOME_TAB_FILTER
    : OPEN_GROUP_TAB_FILTER
}

const CircleDesktopContent = () => {
  const tabFilter = useTertiaryTabFilter()
  const theme = useTheme()
  const direction = theme.direction

  return (
    <CircleTabs
      key={direction}
      direction={direction}
      tabFilter={tabFilter}
      component={() => <CircleContentInner />}
    />
  )
}

const CircleContentInner = ({  }) => {
  const { stack, group, outcome, membership, profile } = useSelector(selectForTertiaryContent)
  const level = stack[stack.length - 1]
  const place = level[level.length - 1]

  switch (place.type) {
    case 'groups/group/activity':
      if (group && !group.closed) {
        return isAllowedToViewContent(group, membership) ? <GroupActivity /> : <PleaseWait i18nKey="group.only_visible_to_members" />
      }
      if (group && group.outcome) {
        return isAllowedToViewContent(group, membership) ? <GroupOutcome outcome={outcome} /> : <PleaseWait i18nKey="group.only_visible_to_members" />
      }
      return (
        <PostsDivision />
      )

    case 'groups/group/outcome':
      if (group && group.closed) {
        return (
          isAllowedToViewContent(group, membership) ? <GroupOutcome outcome={outcome} /> : <PleaseWait i18nKey="group.only_visible_to_members" />
        )
      }

      return (
        <PostsDivision />
      )

    case 'groups/group/posts':
      return (
        <PostsDivision       />
      )
    case 'groups/group/events':
      return (
        <PostsDivision />
      )
    case 'groups/group/reference':
      return (
        <References profile={profile} />
      )
    case 'groups/group/groups':
      return (
        isAllowedToViewContent(group, membership) ? <SubGroups /> : <PleaseWait i18nKey="group.only_visible_to_members" />
      )
    default:
      return <ComingSoon />
  }
}

export default CircleDesktopContent
